import { GPUEngineStatisticsInfo } from "../../../RenderEngine/RenderEnum/RenderStatInfo";
import { WebGLBufferState } from "./WebGLBufferState";
import { WebGLEngine } from "./WebGLEngine";
export class WebGLIndexBuffer {
    constructor(targetType, bufferUsageType) {
        this._glBuffer = this._glBuffer = WebGLEngine.instance.createBuffer(targetType, bufferUsageType);
        WebGLEngine.instance._addStatisticsInfo(GPUEngineStatisticsInfo.RC_IndexBuffer, 1);
    }
    _changeMemory(bytelength) {
        WebGLEngine.instance._addStatisticsInfo(GPUEngineStatisticsInfo.M_IndexBuffer, -this._glBuffer._byteLength + bytelength);
    }
    _setIndexDataLength(data) {
        this._changeMemory(data);
        var curBufSta = WebGLBufferState._curBindedBufferState;
        if (curBufSta) {
            curBufSta.unBind();
            this._glBuffer.bindBuffer();
            this._glBuffer.setDataLength(data);
            curBufSta.bind();
        }
        else {
            this._glBuffer.bindBuffer();
            this._glBuffer.setDataLength(data);
        }
    }
    _setIndexData(data, bufferOffset) {
        var curBufSta = WebGLBufferState._curBindedBufferState;
        if (curBufSta) {
            curBufSta.unBind();
            this._glBuffer.bindBuffer();
            this._glBuffer.setData(data, bufferOffset);
            curBufSta.bind();
        }
        else {
            this._glBuffer.bindBuffer();
            this._glBuffer.setData(data, bufferOffset);
        }
    }
    destroy() {
        this._glBuffer.destroy();
        this._changeMemory(0);
        WebGLEngine.instance._addStatisticsInfo(GPUEngineStatisticsInfo.RC_IndexBuffer, -1);
    }
}
